import { styled } from '@linaria/react';

export const TitleWrapper = styled.div<{ matchStatsEnabled: boolean }>`
  --title-empty-space: ${props => (props.matchStatsEnabled ? '42px' : '0px')};
  width: 100%;
  margin: 0;
  padding: 5px 10px;
  border-top: 1px solid var(--oc-line-secondary);
  border-bottom: 1px solid var(--oc-line-secondary);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--oc-bg-grey);

  @media (min-width: 768px) {
    padding: 5px 20px;
  }
`;

export const Title = styled.p`
  display: none;
  min-width: calc(100% - var(--oc-odds-columns-width) - var(--title-empty-space));
  font-family: var(--oc-font-family);
  font-size: 13px;
  font-weight: 700;
  color: var(--ogm-text-body);

  white-space: nowrap;
  text-transform: uppercase;

  @media (min-width: 768px) {
    display: inline-block;
  }
`;

export const MobileTitle = styled(Title)`
  display: inline-block;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const Labels = styled.div<{ tabletUpMarginRight: number }>`
  display: grid;
  grid-template-columns: repeat(var(--oc-columns-number), calc(var(--oc-best-odds-width) * 1px));
  grid-column-gap: 4px;
  align-items: center;
  justify-content: baseline;
  min-width: 130px;
  margin-left: auto;

  @media (min-width: 768px) {
    grid-column-gap: 8px;
    margin-right: ${props => `${props.tabletUpMarginRight}px`};
  }
`;

export const Label = styled.label`
  display: inline-block;
  min-width: calc(var(--oc-best-odds-width) * 1px);
  margin: 0;
  padding: 0;
  text-transform: uppercase;

  font-family: var(--ogm-font-family-2);
  font-size: 10px;
  font-weight: 400;
  color: var(--ogm-text-body);
  text-align: center;
  line-height: 15px;

  @media (min-width: 768px) {
    line-height: 16.37px;
  }

  @media (min-width: 768px) {
    display: none;
  }

  & span {
    display: block;
    text-transform: uppercase;
    font-size: inherit;
    font-weight: inherit;
    text-align: inherit;
  }
`;

export const LabelDesktop = styled(Label)`
  display: none;

  @media (min-width: 768px) {
    display: inline-block;
  }
`;
